<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" :key="$route.query.t" />
  </div>
</template>

<script>
export default {
  name: "App",
  mounted() {
    // window.onresize = ()=>{
    //   document.documentElement.style.fontSize = `calc(${(100 / (document.body.clientWidth * 2)) * 100}vw)`;
    // }
    // document.documentElement.style.fontSize = `calc(${(100 / (document.body.clientWidth * 2)) * 100}vw)`;
    if (
      typeof WeixinJSBridge == "object" &&
      // eslint-disable-next-line no-undef
      typeof WeixinJSBridge.invoke == "function"
    ) {
      handleFontSize();
    } else {
      document.addEventListener("WeixinJSBridgeReady", handleFontSize, false);
    }
    function handleFontSize() {
      // 设置网页字体为默认大小
      // eslint-disable-next-line no-undef
      WeixinJSBridge.invoke("setFontSizeCallback", { fontSize: 0 });
      // 重写设置网页字体大小的事件
      // eslint-disable-next-line no-undef
      WeixinJSBridge.on("menu:setfont", function () {
        // eslint-disable-next-line no-undef
        WeixinJSBridge.invoke("setFontSizeCallback", { fontSize: 0 });
      });
    }
  },
};
</script>

<style lang="less">
@import url("./styles/index.less");
@import url("./styles/iconfont.css");
#app {
  // max-width: 640px;
  // margin: 0 auto;
  // height: 100vh;
}
/*修改滚动条样式*/
div::-webkit-scrollbar {
  width: 0px;
  height: 10px;
}
div::-webkit-scrollbar-track {
  background: rgb(239, 239, 239);
  border-radius: 2px;
}
div::-webkit-scrollbar-thumb {
  background: #bfbfbf;
  border-radius: 10px;
}
div::-webkit-scrollbar-thumb:hover {
  background: #333;
}
div::-webkit-scrollbar-corner {
  background: #179a16;
}
.refund_title .van-dialog__content .van-dialog__message{
  font-weight: 800;
  font-size: 1rem;
}
</style>
